import flagPlaceholder from 'src/assets/images/flags/flag.svg';
import franceFlag from 'src/assets/images/flags/french.jpg';
import germanyFlag from 'src/assets/images/flags/germany.jpg';
import netherlandsFlag from 'src/assets/images/flags/netherlands.png';
import polandFlag from 'src/assets/images/flags/poland.png';
import portugalFlag from 'src/assets/images/flags/portugal.png';

const countryFlags = {
    DE: germanyFlag,
    FR: franceFlag,
    NL: netherlandsFlag,
    PL: polandFlag,
    PT: portugalFlag,
};

export const getCountryFlag = (countryCode) => countryFlags[countryCode] || flagPlaceholder;
